// extracted by mini-css-extract-plugin
export default {"hotspotsList":"index_hotspotsList_TES9x","hotspotsItem":"index_hotspotsItem_H03wK"};